module.exports = __webpack_public_path__ + "static/media/nav_favorite.de1d6dd5.svg";